export default "/_next/static/images/3a818fcf3395f807838fa5713f3c44b4.jpg";